import _ from 'lodash';
import { createSelector } from 'reselect';

import { getIsFromInternalCompany } from 'store/auth/selectors/master.selectors';

import { getSystem } from './system.selectors';

const selectKnowledgeItemsState = createSelector(getSystem, ({ knowledgeItems }) => knowledgeItems);

export const selectKnowledgeItems = createSelector(
  selectKnowledgeItemsState,
  ({ knowledgeItems }) => knowledgeItems,
);

const selectKnowledgeItemById = _.memoize(id =>
  createSelector(selectKnowledgeItems, knowledgeItems =>
    knowledgeItems.find(item => item.id === id),
  ),
);

export const selectIsKnowledgeItemReadOnly = _.memoize(id =>
  createSelector(
    [selectKnowledgeItemById(id), getIsFromInternalCompany],
    (item, isInternalCompany) => {
      if (!item || isInternalCompany) {
        return false;
      }

      return !!item.isGlobal;
    },
  ),
);

export const selectBusyKnowledgeItemsNames = _.memoize(id =>
  createSelector(selectKnowledgeItems, knowledgeItems =>
    knowledgeItems.reduce((acc, item) => {
      if (item.id !== id) {
        acc.push(item.name);
      }

      return acc;
    }, []),
  ),
);

export const selectKnowledgeItemsOptions = createSelector(selectKnowledgeItems, knowledgeItems =>
  knowledgeItems.map(({ id, name, description, injectionMode, contentLength }) => ({
    value: id,
    name,
    description,
    injectionMode,
    contentLength,
  })),
);
